<ng-container>

  <div>
    <b>{{ name }}</b>
    <app-info class="formGroupLabel" [wide]="false" [placement]="'left'">
      <div class="tooltipContent">
        <b>Considering</b>
        <ul>
          @for (consider of splitConsidering(); track consider) {
            <div>
              <li>
                {{ consider }}
              </li>
            </div>
          }
        </ul>
      </div>
    </app-info>
  </div>

  <ng-container>
    <div class="row">
      <div class="col-md fieldset">
        <app-visit-exemptions-exemption-common [exemption]="exemption"></app-visit-exemptions-exemption-common>
        <div class="col-md">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Substance (Proper shipping name)</label>
            </app-info>
            <app-search [(ngModel)]="dangerousGoods" dataKey="name"
                        (ngModelChange)="onDangerousGoodsChange(dangerousGoods)"
                        [inputFormatter]="portVisitUtils.dangerousGoodsFormatter"
                        [searchFunction]="portVisitUtils.findDangerousGoods"
                        [resultFormatter]="portVisitUtils.dangerousGoodsFormatter"
                        placeholder="Find by name or UN code">
            </app-search>
          </app-form-group>
        </div>
        <div class="col-md">
          <app-form-group label="Substance name">
            <textarea [(ngModel)]="exemption.substanceName" id="substanceName" type="text" rows="3" maxlength="1024"
                      class="form-control" required></textarea>
          </app-form-group>
        </div>
        <div class="col-md">
        </div>
        <div class="col-md">
          <app-form-group label="UN number">
            <input [(ngModel)]="exemption.unVnNumber" id="unVnNumber" type="text" maxlength="256"
                   class="form-control" required>
          </app-form-group>
        </div>
      </div>
      <div class="col-md fieldset">
        <div class="col-md">
          <app-form-group label="Where does the transshipment take place ?">
            <app-select [(ngModel)]="exemption.placeType" (ngModelChange)="resetVesselInfo(true)" id="placeType"
                        [options]="placeTypes" required>
            </app-select>
          </app-form-group>
        </div>
        <div class="col-md">
        </div>

        <div class="col-md">
          @if (exemption.placeType == ANOTHER_VESSEL) {
            <app-form-group label="Vessel type">
              <app-select [(ngModel)]="exemption.vesselType" (ngModelChange)="resetVesselInfo(false)" id="vesselType"
                          [options]="vesselTypes"
                          [formatter]="vesselTypesFormatter" required>
              </app-select>
            </app-form-group>
          }
          @if (exemption.vesselType === 'IMO' && exemption.placeType == ANOTHER_VESSEL) {
            <app-form-group>
              <app-info class="formGroupLabel">
                <label>Vessel name/IMO number</label>
                <div class="tooltipContent">Name of vessel receiving cargo being pumped over</div>
              </app-info>
              <app-search [(ngModel)]="vessel" (ngModelChange)="onVesselChange(vessel)" [searchFunction]="searchVessel"
                          [inputFormatter]="vesselNameFormatter"
                          [minCharacters]="3" dataKey="imoCode" id="vessel">
              </app-search>
            </app-form-group>
          }
        </div>
        <div class="col-md">
          @if (exemption.vesselType === 'IMO' && exemption.placeType == ANOTHER_VESSEL) {
            <app-form-group label="Vessel name"
            >
              <input [(ngModel)]="exemption.vesselNameIMO" id="vesselNameIMO" type="text" maxlength="64"
                     class="form-control" readonly required>
            </app-form-group>
          }
          @if (exemption.vesselType === 'IMO' && exemption.placeType == ANOTHER_VESSEL) {
            <app-form-group label="Vessel IMO"
            >
              <input [(ngModel)]="exemption.vesselIMO" id="vesselIMO" type="text" maxlength="64"
                     class="form-control" readonly required>
            </app-form-group>
          }
          @if (exemption.vesselType === 'ENI' && exemption.placeType == ANOTHER_VESSEL) {
            <app-form-group label="Vessel name"
            >
              <input [(ngModel)]="exemption.vesselNameENI" id="vesselNameENI" type="text" maxlength="64"
                     class="form-control" required>
            </app-form-group>
          }
          @if (exemption.vesselType === 'ENI' && exemption.placeType == ANOTHER_VESSEL) {
            <app-form-group label="Vessel ENI"
            >
              <input [(ngModel)]="exemption.vesselENI" id="vesselENI" type="text" maxlength="64"
                     class="form-control" required>
            </app-form-group>
          }
        </div>

        <div class="col-md">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Reason</label>
              <div class="tooltipContent">What is the reason the fixed pump or hose cannot be used?</div>
            </app-info>
            <app-search [(ngModel)]="exemption.reasonOther" [required] [searchFunction]="searchReasonse"
                        placeholder="Select one of the options or type a new one"
                        [newValueFromInputFunction]="newReason" [minCharacters]="0"></app-search>
          </app-form-group>
        </div>

        <div class="col-md">
          <app-form-group label="Has permission been granted by the terminal concerned ?">
            <app-yes-no [(ngModel)]="exemption.hasPermissionBeenGranted" id="hasPermissionBeenGranted"
                        required></app-yes-no>
          </app-form-group>
        </div>
        <div class="col-md">
        </div>

        <div class="col-md">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Reason for request for exemption</label>
              <div class="tooltipContent">A minimum of 20 characters is required</div>
            </app-info>
            <textarea [(ngModel)]="exemption.reason" id="reason" type="text" rows="3" minlength="20" maxlength="1024"
                      class="form-control" required></textarea>
          </app-form-group>
        </div>
        <div class="col-md">
          <app-form-group label="Details">
            <textarea [(ngModel)]="exemption.details" id="details" type="text" rows="3" maxlength="256"
                      class="form-control"></textarea>
          </app-form-group>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
